<template>
	<div class="app" style="width: 100%;">
		<el-container direction="vertical">
			<el-header style="padding:0;height: auto;">
				<IndexHead style="width:100%;"></IndexHead>
			</el-header>
			<el-main style="padding:0;" v-if="type==0">
				<div class="text color flex justify-align-center" style="font-size: 23px;height:85px;margin-top: 10px;">
					查学校 &nbsp; 查双选会 &nbsp;查专业 &nbsp; 就用HR校招助手
				</div>
				<div class="rou flex justify-align-center">
					<div :class="type1==1?'actives':''" @click="clicktype1()" class="xiaoshou">按学院查询</div>
					<div :class="type1==2?'actives':''" @click="clicktype2()" class="xiaoshou">按专业查询</div>
					<div :class="type1==3?'actives':''" @click="clicktype3()" class="xiaoshou">查双选会</div>
				</div>
				<div class="search flex justify-align-center" style="margin-left: 90px;">
					<input v-model="input" class="borders" :placeholder="placeholder" @keyup.enter.prevent="searchEnterFun($event)"
						style="width:320px;height:24px;border:1px solid;padding:3px 5px;font-size:12px;"></input>
					<div style="width: 100px;">
						<el-button class="backbg borders" :loading="buttonLoading"
							style="color:#FFFFFF;border: none;margin: 0 20px;padding:8px 18px;font-size: 12px;"
							@click="query('tap')">查询</el-button>
					</div>
				</div>
				<div class="flex justify-align-center font" style="color: #aaaaaa;margin: 10px 0;margin-right: 127px;">
					（注：免费注册会员即可使用搜索功能）</div>
				<el-row type="flex" justify="center">
					<el-col :span="22">
					<div style="font-size: 12px;margin-bottom:10px;text-align: left;">院校所在地</div>
					<div class="jis" style=" ">
						<div class="flex font" style="margin-top: 0;">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 10px;">省级</div>
							<div :class="indexl=='不限'?'color':''" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 10px;" @click="shengji()">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="indexl==index?'color':''" style="margin-right: 20px;margin-top: 10px;"
									class="xiaoshou" v-for="(item,index) in city" :key="index" @click="leibie(index)">
									{{item.name}}</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">市级</div>
							<div :class="index2=='不限'?'color':''" @click="shiji" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="index2==index?'color':''" style="margin-right: 20px;margin-top: 5px;"
									class="xiaoshou" v-for="(item,index) in citys" :key="index"
									@click="getCitys(index)">{{item.name}}
								</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">双选会</div>
							<div :class="xingshilist==''?'color':''" @click="sdfsdf" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;">不限</div>
							<div style="color:#666666;width:80%;margin-top: 5px;" class="flex row_wrap">
								<el-radio-group v-model="xingshilist" @change="checkboxchange">
									<el-radio v-for="(item,index) in sxhxingshi" :key="index" :label="item.name">{{item.name}}</el-radio>
								</el-radio-group>
								<!-- <el-checkbox-group size="mini" fill="#42b983" text-color="#42b983" v-model="xingshilist"
									style="display:flex;" @change="checkboxchange">
									<el-checkbox :label="item.name" v-for="(item,index) in sxhxingshi" :key="index"
										:value="item.name"></el-checkbox>
								</el-checkbox-group> -->
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">院校类型</div>
							<div :class="index3=='不限'?'color':''" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;" @click="yuanx">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="index3==index?'color':''" style="margin-right: 20px;margin-top: 5px;"
									class="xiaoshou" v-for="(item,index) in yuanxiao" :key="index"
									@click="yuanxi(index)">{{item.name}}
								</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">主管部门</div>
							<div :class="index4=='不限'?'color':''" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;" @click="zhug">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="index4==index?'color':''" style="margin-right: 20px;margin-top: 5px;"
									class="xiaoshou" v-for="(item,index) in competent" :key="index"
									@click="zhuguan(index)">{{item.name}}
								</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">学历层次</div>
							<div :class="index5=='不限'?'color':''" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;" @click="xuel">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="index5==index?'color':''" style="margin-right: 20px;margin-top: 5px;"
									class="xiaoshou" v-for="(item,index) in level" :key="index" @click="xueli(index)">
									{{item.name}}</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">实习离校</div>
							<div :class="index6=='不限'?'color':''" class="xiaoshou"
								style="margin-right: 20px;min-width:31px;margin-top: 5px;" @click="shixi">不限</div>
							<div style="color:#666666;width:80%;" class="flex row_wrap">
								<div :class="index6==index?'color':''" style="margin-right: 20px;margin-top: 5px;"
									class="xiaoshou" v-for="(item,index) in internship" :key="index"
									@click="shixilx(index)">
									{{item.name}}
								</div>
							</div>
						</div>
						<div class="flex font">
							<div style="margin-right: 30px;text-align: end;min-width:50px;margin-top: 5px;">院校特性</div>
							<div style="color:#666666;width:80%;margin-top: 5px;" class="flex row_wrap">
								<el-checkbox-group @change="tezheng" size="mini" fill="#42b983" text-color="#42b983"
									v-model="checked" style="display:flex;">
									<el-checkbox :label="item.name" v-for="(item,index) in features" :key="index"
										:value="item.name"></el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
					</div>
				<!-- </div> -->
				</el-col>
				</el-row>
				<el-row type="flex" justify="center">
					<el-col :span="22">
						<div v-if="type1==1||type1==2" class="biao font" style="margin: 20px auto;margin-bottom: 10px;">
							<el-table :data="tableData" :row-style="{height:'10px'}" :row-class-name="tableRowClassName"
								@row-click="onRowClick" style="width: 100%">
								<el-table-column prop="name" label="院校名称" width="152px" header-align="center" align="left">
									
								</el-table-column>
								<el-table-column prop="new" label="最新双选会" header-align="center" align="center" min-width="155px">
									<template slot-scope="scope">
										<div v-if="scope.row.last_meeting">
										{{scope.row.last_meeting.begin_date == scope.row.last_meeting.end_date ? timeFilter(scope.row.last_meeting.begin_date) : `${timeFilter(scope.row.last_meeting.begin_date)} - ${timeFilter(scope.row.last_meeting.end_date,true)}`}}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="meeting_type" label="形式" header-align="center" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.last_meeting">{{scope.row.last_meeting.meeting_type}}</div>
									</template>
								</el-table-column>
								<el-table-column prop="city_name" label="地点" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="education" label="学历" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="university_type" label="类型" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="manage_dept" label="主管部门" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="leaving_school" label="实习离校" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="jiubw" type="index" label="985" width="30px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('985')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="eryy" label="211" width="30px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('211')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="yiliu" label="一流大学" width="50px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('一流大学')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="xuek" label="一流学科" width="50px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('一流学科')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="yanjiu" label="研究生院" width="50px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('研究生院')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="shuos" label="有硕士" width="45px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('有硕士')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="boshi" label="有博士" width="45px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('有博士')!=-1"
											src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
										<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
									</template>
								</el-table-column>
								<el-table-column prop="shouc" label="收藏" width="35px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.collect_flag==1" src="../assets/img/xing1.png"
											style="width:14px;height:14px;"></img>
										<img v-if="scope.row.collect_flag!=1" src="../assets/img/xing2.png"
											style="width:14px;height:14px;"></img>
									</template>
								</el-table-column>
								<el-table-column prop="guanz" label="关注" width="35px" header-align="center" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.follow_flag==1" src="../assets/img/xin1.png"
											style="width:14px;height:14px;"></img>
										<img v-if="scope.row.follow_flag!=1" src="../assets/img/xin2.png"
											style="width:14px;height:14px;"></img>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-if="type1==3" class="biao font" style="margin: 20px auto;margin-bottom: 10px;">
							<el-table :data="tablelist" :row-style="{height:'10px'}" :row-class-name="tableRowClassName"
								@row-click="onRowClick" style="width: 100%">
								<el-table-column prop="serial_num" label="序号" width="100px" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="university[name]" label="院校名称" header-align="center" align="left">
								</el-table-column>
								<el-table-column prop="time" label="双选会时间" header-align="center" align="center">
									<template slot-scope="scope">
										<div>{{scope.row.begin_date == scope.row.end_date ? scope.row.begin_date : `${scope.row.begin_date} - ${scope.row.end_date}`}}</div>
									</template>
								</el-table-column>
								<el-table-column prop="meeting_type" label="双选会形式" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="name" label="双选会名称" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="invalid_flag" label="是否过期" header-align="center" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.invalid_flag==0">未过期</div>
										<div v-else>已过期</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="font flex all-justify-end align-center" style="margin: 10px auto;text-align: end;">
							<el-pagination hide-on-single-page layout="prev, pager, next,jumper" :page-size="30"
								:total="total" :current-page="page" @current-change="currentPage">
							</el-pagination>
							<!-- <div class="flex" style="margin-left: 10px;">
												<div :class="page==1?'ye1 color':'ye1'" >1</div>
												<div class="ye2" @click="pages()">Go</div>
											</div>
						-->
						</div>
					</el-col>
				</el-row>
			</el-main>
			<UniInfor v-if='type==1' :rowInfors="rowInforss" @types="types"></UniInfor>
			<el-footer style="padding:0;height: 30px;margin-top: 60px;">
				<div class="font" style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;">
					版权所有：HR校招助手网 <span style="width: 100px;display: inline-block;"></span> CNZZ
				</div>
			</el-footer>
		</el-container>
		<div style="height: 50px;width: 100%;"></div>
	</div>
</template>



<script>
	var four;
	
	function Topfun() {
	
		four = setInterval(FourscrollBy, 10);
	
	}
	
	
	function FourscrollBy(eachHeight) {
	
		if (document.documentElement && document.documentElement.scrollTop) //IE
	
		{
	
			if (document.documentElement.scrollTop <= 0) {
	
				clearInterval(four);
	
			} else {
	
				window.scrollBy(0, -30);
	
			}
	
		} else { //Chrome不支持documentElement.scrollTop
	
			if (document.body.scrollTop <= 0) {
	
				clearInterval(four);
	
			} else {
	
				window.scrollBy(0, -30);
	
			}
	
		}
	
	}
	import IndexHead from '../components/IndexHead.vue';
	import UniInfor from '../components/UniInfor.vue';
	export default {
		name: 'index',
		components: {
			IndexHead,
			UniInfor
		},
		data() {
			return {
				rowInforss: {},
				type: 0,
				// 表格的页码
				page: 1,
				indexl: '不限',
				index2: '不限',
				index3: '不限', //院校
				index4: '不限', //主管
				index5: '不限', //学历层次
				index6: '不限', //实习离校
				// 搜索框绑定的值
				input: '',
				// 搜索类型 1学校 2专业 3双选会
				type1: 1,
				placeholder: '请输入院校名称，也可以不输入',
				// 省级列表
				sjlist: [],
				//双选会中的序号
				// 选中table里的第几行
				index: '',
				// 按学校,专业查询列表
				tableData: [],
				// 按双选会查询列表
				tablelist: [],
				// 省级列表
				city: [],
				// 省下市级列表
				citys: [],
				//院校类型列表
				yuanxiao: [],
				// 主管部门列表
				competent: [],
				//实习离校列表
				internship: [],
				//学历层次列表
				level: [],
				//院校特征列表
				features: [],
				sxhxingshi: [{
					name: '校园'
				}, {
					name: '网络'
				}],
				//选中列表
				checked: [],
				xingshilist: '', //双选会形式
				checklist: [], //院校默认
				total: 0, //数据总数
				buttonLoading: false, //按钮加载状态
				user_search_limit: 3,//普通会员可以查看的条数
			}
		},
		async mounted() {
			if(window.localStorage.getItem('shuju')){
				let object = JSON.parse(window.localStorage.getItem('shuju'))
				this.rowInforss = object
				this.index = object.index;
				window.localStorage.removeItem('shuju')
				this.type = 1;
			}
			// 获取省级类型
			this.getCity();
			// 获取院校类型
			this.getTypes();
			//获取主管部门列表
			this.comdepart();
			//获取学历层次列表
			this.geteduclevel();
			//获取实习离校列表
			this.getinternship();
			//获取院校特征
			this.getfeatures();
			//查询
			if (window.localStorage.getItem('token')) {
				this.$store.commit('ISLOGIN', true)
				await this.$axios.get(`/api/user/getUserByToken?api_token=${window.localStorage.getItem('token')}`)
					.then(res => {
						if(res.data.data.name) {
							this.$store.commit('USERNAME', res.data.data.name);
						}else{
							this.$store.commit('USERNAME', res.data.data.mobile);
						}
						this.$store.commit('ISVIP', res.data.data.vip_flag);
					})
			}
			await this.$axios.get('/api/site/conf').then(res => {
				this.user_search_limit = res.data.data.user_search_limit
			})
			this.query();
		},
		methods: {
			checkboxchange(){
				this.query('tap')
			},
			searchEnterFun(e){
				var keyCode = window.event ? e.keyCode : e.which;
				if (keyCode == 13) this.query('tap');
			},
			clicktype1() {
				this.type1 = 1;
				this.page = 1;
				this.placeholder = '请输入院校名称，也可以不输入';
				this.query('tap');
			},
			clicktype2() {
				this.type1 = 2;
				this.page = 1;
				this.placeholder = '请输入专业名称，多个专业用逗号隔开';
				this.query('tap');
			},
			clicktype3() {
				//查询
				this.type1 = 3;
				this.page = 1;
				this.placeholder = '请输入双选会，也可以不输入';
				this.query('tap');
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				//把每一行的索引放进row
				row.index = rowIndex;
				if(rowIndex > this.user_search_limit-1 && this.$store.state.isvip == 0) return 'xuhua'
				// console.log(row,"row");
			},
			onRowClick(row, event, column) {
				// console.log(index,"index");
				// console.log(dom)
				if(row.index > this.user_search_limit-1 && this.$store.state.isvip == 0) return this.$message.warning('成为VIP会员后才可查看哦');
				if (event.label == '收藏') {
					if (this.tableData[row.index].collect_flag == 0) {
						this.$axios
							.post(`/api/university/collect`, {
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if (res.data.code == 200) {
									this.tableData[row.index].collect_flag = 1
								} else {
									this.$message.error(res.data.msg)
								}
							});
					} else {
						this.$axios
							.post(`/api/university/unCollect`, {
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if (res.data.code == 200) {
									this.tableData[row.index].collect_flag = 0
								} else {
									this.$message.error(res.data.msg)
								}
							});
					}
				} else if (event.label == '关注') {
					if (this.tableData[row.index].follow_flag == 0) {
						this.$axios
							.post(`/api/university/follow`, {
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if (res.data.code == 200) {
									this.tableData[row.index].follow_flag = 1
								} else {
									this.$message.error(res.data.msg)
								}
							});
					} else {
						this.$axios
							.post(`/api/university/unFollow`, {
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if (res.data.code == 200) {
									this.tableData[row.index].follow_flag = 0
								} else {
									this.$message.error(res.data.msg)
								}
							});
					}
				} else {
					if(row.url_type == 2){
						window.open(row.url)
					}else{
						if(row.begin_date){
							window.localStorage.setItem('shuju',JSON.stringify(row.university))
						}else{
							window.localStorage.setItem('shuju',JSON.stringify(row))
						}
						window.open(`http://www.xiaozhaozhushou.net/`)
						// window.open(`http://localhost:8081/`)
						// if(row.begin_date){
						// 	this.rowInforss = row.university
						// }else{
						// 	this.rowInforss = row;
						// }
						// this.index = row.index;
						// this.type = 1;
						// Topfun()
					}
				}
			},

			// 选中类别时的方法
			leibie(index) {
				this.indexl = index;
				this.$axios
					.get(`/api/city/citys?province_id=${this.city[index].id}`)
					.then((res) => {
						// console.log(res,"res");
						this.citys = res.data.data;
					});
					this.query('tap')
			},
			// 选中市级时
			getCitys(index) {
				this.index2 = index;
				this.query('tap')
			},
			// 选中院校时
			yuanxi(index) {
				this.index3 = index;
				this.query('tap')
			},
			// 选中主管部门时
			zhuguan(index) {
				this.index4 = index;
				this.query('tap')
			},
			// 选中学历层次时
			xueli(index) {
				this.index5 = index;
				this.query('tap')
				// this.index5 = 0;
			},
			// 选中实习离校时
			shixilx(index) {
				this.index6 = index;
				this.query('tap')
			},
			// 选中省级不限时
			shengji() {
				this.indexl = '不限';
				this.query('tap')
			},
			// 选中市级不限时
			shiji() {
				this.index2 = '不限';
				this.query('tap')
			},
			// 选中院校不限时
			yuanx() {
				this.index3 = '不限';
				this.query('tap')
			},
			//选中主管部门不限时
			zhug() {
				this.index4 = '不限';
				this.query('tap')
			},
			//选中学历层次不限时
			xuel() {
				this.index5 = '不限';
				this.query('tap')
			},
			//选中实习离校不限时
			shixi() {
				this.index6 = '不限';
				this.query('tap')
			},
			//页码
			pages() {
				if (this.page != 1) {
					this.page = 1;
					this.query();
				}
			},
			currentPage(val) {
				// console.log(val,"e");
				this.page = val;
				this.query();
			},
			prevPage() {
				this.page--;
				this.query();
				console.log(this.page, "prev");
			},
			nextPage() {
				this.page++;
				this.query();
				console.log(this.page, "next");
			},
			// 校园详情返回首页
			types(val) {
				this.type = val;
			},
			// 获取省级
			getCity() {
				this.$axios
					.post('/api/city/provinces')
					.then((res) => {
						// console.log(res,"res");
						this.city = res.data.data;
					});
			},
			// 获取院校类型
			getTypes() {
				this.$axios
					.get(`/api/dictVal/getBySlug?p_slug=university_type`)
					.then((res) => {
						// console.log(res,"res");
						this.yuanxiao = res.data.data;
					});
			},
			//获取主管部门
			comdepart() {
				this.$axios
					.get(`/api/dictVal/getBySlug?p_slug=manage_dept`)
					.then((res) => {
						// console.log(res,"res");
						this.competent = res.data.data;
					});
			},
			//获取学历层次
			geteduclevel() {
				this.$axios
					.get(`/api/dictVal/getBySlug?p_slug=education`)
					.then((res) => {
						// console.log(res,"res");
						this.level = res.data.data;
					});
			},
			//获取实习离校
			getinternship() {
				this.$axios
					.get(`/api/dictVal/getBySlug?p_slug=leaving_school`)
					.then((res) => {
						// console.log(res,"res");
						this.internship = res.data.data;
					});
			},
			//获取院校特征
			getfeatures() {
				this.$axios
					.get(`/api/dictVal/getBySlug?p_slug=university_feature`)
					.then((res) => {
						// console.log(res,"res");
						this.features = res.data.data;
					});
			},
			sdfsdf(){
				this.xingshilist = ''
				this.query('tap')
			},
			// 复选院校特征
			tezheng(e) {
				console.log(e, "e")
				this.query('tap')
			},
			// 查询
			query(type) {
				if(!window.localStorage.getItem('token') && type){
					this.$message.warning('登陆后才可以使用搜索功能哦');
					setTimeout(() => {
						this.$router.push('/login')
					},1500)
					return
				}
				if(type) this.page = 1
				var city = '';
				var citys = '';
				var yuanxiao = '';
				var competent = '';
				var internship = '';
				var level = '';
				var token = '';
				// console.log(this.city[this.index1],"cityId");
				if (this.indexl == '不限') {
					city = '';
				} else {
					city = this.city[this.indexl].id;
				}
				if (this.index2 == '不限') {
					citys = '';
				} else {
					citys = this.citys[this.index2].id
				}
				if (this.index3 == '不限') {
					yuanxiao = ''
				} else {
					yuanxiao = this.yuanxiao[this.index3].val
				}
				if (this.index4 == '不限') {
					competent = ''
				} else {
					competent = this.competent[this.index4].val
				}
				if (this.index5 == '不限') {
					internship = ''
				} else {
					internship = this.level[this.index5].val
				}
				if (this.index6 == '不限') {
					level = '';
				} else {
					level = this.internship[this.index6].val
				}
				if (window.localStorage.getItem('token')) {
					token = window.localStorage.getItem('token');
				} else {
					token = '';
				}
				this.buttonLoading = true;
				console.log(this.$store.state.isvip)
				if (this.type1 == 3) {
					this.$axios
						.get(
							`/api/meeting/search?page_size=30&page=${this.page}&province_id=${city}&city_id=${citys}&university_type=${yuanxiao}&manage_dept=${competent}&education=${internship}&leaving_school=${level}&university_feature=${this.checked}&name=${this.input}&api_token=${token}&meeting_type=${this.xingshilist}`
						)
						.then((res) => {
							this.buttonLoading = false
							this.tablelist = res.data.data.list;
							this.total = this.$store.state.isvip == 1 ? res.data.data.total : 3;
						});
				} else if (this.type1 == 1) {
					this.$axios
						.get(
							`api/university/searchXy?page_size=30&page=${this.page}&province_id=${city}&city_id=${citys}&university_type=${yuanxiao}&manage_dept=${competent}&education=${internship}&leaving_school=${level}&university_feature=${this.checked}&name=${this.input}&api_token=${token}&meeting_type=${this.xingshilist}`
						)
						.then((res) => {
							this.buttonLoading = false
							this.tableData = res.data.data.list;
							this.total = this.$store.state.isvip == 1 ? res.data.data.total : 3;
						});
				} else {
					this.$axios
						.get(
							`api/university/searchZy?page_size=30&page=${this.page}&province_id=${city}&city_id=${citys}&university_type=${yuanxiao}&manage_dept=${competent}&education=${internship}&leaving_school=${level}&university_feature=${this.checked}&name=${this.input}&api_token=${token}&meeting_type=${this.xingshilist}`
						)
						.then((res) => {
							this.buttonLoading = false
							this.tableData = res.data.data.list;
							this.total = this.$store.state.isvip == 1 ? res.data.data.total : 3;
						});
				}
			}
		}
	}
</script>
<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #2c3e50;
	}

	#navs {
		display: flex;
		justify-content: space-around;
	}

	.rou {
		margin-bottom: 25px;

		div {
			font-size: 12px;
			// color: #2c3e50;
			padding: 4px 0px;
			margin: 0 15px;

			&:active {
				color: #42b983;
				border-bottom: 2px solid #42b983;
			}
		}
	}

	.jis>div {
		margin-top: 5px;
	}

	.actives {
		color: #42b983;
		border-bottom: 2px solid #42b983;
	}

	.el-checkbox__label {
		font-size: 12px !important;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #42b983;
		border-color: #42b983;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #42b983;
	}

	.el-checkbox__inner:hover {
		border-color: #42b983;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner:hover {
		border-color: #42b983;
	}

	.el-table {
		border: 1px solid #EBEEF5;
		font-size: 12px !important;
	}

	.el-table td {
		padding: 6px 0px !important;
		margin: 6px !important;
		// text-align: center;
	}

	.el-table th {
		margin: 0 10px !important;
		padding: 6px 0px !important;
		// text-align: center;
	}

	.el-table thead {
		color: #000000;
		font-weight: 400 !important;
	}

	.el-table th>.cell {
		padding: 0;
	}

	.el-table .cell {
		padding: 0;
	}

	.el-pager>li {
		min-width: 24px !important;
		height: 20px;
		line-height: 20px;
		border: 1px solid #EBEEF5;
		margin: 5px;
		font-size: 12px;
		color: #999999;
	}

	.el-pager li.active {
		color: #42b983;
	}

	.el-pager li:hover {
		color: #42b983;
	}

	.el-pagination .btn-next,
	.el-pagination .btn-prev {
		border: 1px solid #EBEEF5;
		height: 20px;
		line-height: 20px;
	}

	.el-pagination {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.el-pagination button:hover {
		color: #42b983;
	}

	.ye2,
	.ye1 {
		border: 1px solid #EBEEF5;
		height: 20px;
		line-height: 20px;
		padding: 0 4px;
		color: #999999;
		font-weight: 700;
	}

	.ye1 {
		padding: 0 8px;
	}

	.ye1:hover,
	.ye2:hover {
		color: #42b983;
	}

	input {
		outline: none;
	}
	.xuhua{
		background: rgba(197, 197, 197, 0.6) !important;
		color: #999999;
		// &:after{
		// 	position: absolute;
		// 	left: 0;
		// 	content: '';
		// 	top: 0;
		// 	// bottom: 0;
		// 	// height: 35px;
		// 	height: 100%;
		// 	width: 100%;
		// 	background: rgba(197, 197, 197, 0.2);
		// }
	}
	.el-radio__inner{
		height: 12px;
		width: 12px;
	}
	.el-radio__input.is-checked .el-radio__inner{
		border-color: #42b983;
		background: #42b983;
	}
	.el-radio__label{
		font-size: 12px;
	}
	.el-radio__input.is-checked+.el-radio__label{
		color: #42b983;
		font-size: 12px;
	}
</style>
